import { lazy } from 'react'
// import Index from '../pages/index'
const Index = lazy(() => import('../pages/index/index'))
const AIPage = lazy(() => import('../pages/AIPage'))
const WisdomPage = lazy(() => import('../pages/WisdomPage'))
const ProductGpu = lazy(()=> import('../pages/ProductGpu'))
const ContactUs = lazy(()=> import('../pages/ContactUs'))
const AboutUS = lazy(()=> import('../pages/AboutUS'))
const ProductAI = lazy(()=> import('../pages/ProductAI'))



const route = [
    {
        path: '/',
        key: 'Index',
        element: <Index/>,
    },
    {
        path: '/productGpu/:id',
        key: 'ProductGpu',
        element: <ProductGpu/>,
    },
    {
        path: '/aiPage',
        key: 'AIPage',
        element: <AIPage/>,
    },
    {
        path: '/wisdomPage',
        key: 'WisdomPage',
        element: <WisdomPage/>,
    },
    {
        path: '/contact',
        key: 'contact',
        element: <ContactUs/>,
    },
    {
        path: '/aboutUs',
        key: 'AboutUS',
        element: <AboutUS/>,
    },
    {
        path: '/productAI/:id',
        key: 'ProductAI',
        element: <ProductAI/>,
    }
]
export default route;